import LangEnum from '../../../../../../../../lang/LangEnum';
import { OrderProductSelectedPack } from '../../../../../../../products/details/productDetails.types';
import { TranslateType } from '../../../../../../../translation/translationContext.types';

export const getPacksButtonLabel = (
  selectedPacks: OrderProductSelectedPack[],
  translate: TranslateType,
) => {
  if (selectedPacks.length === 1) {
    const { packName, quantity } = selectedPacks[0];
    return quantity === 1 ? packName : `${quantity}x ${packName}`;
  } else if (selectedPacks.length > 1) {
    return `${selectedPacks.length} ${translate(LangEnum.GLOBAL_PACKS)}`;
  }
  return translate(LangEnum.GLOBAL_PACKS);
};
